// Gruppierung der Gesprächsliste (DESIGN §3.3.4): „Pinned“, dann Today · Yesterday ·
// Previous 7 days · Previous 30 days · „October 2026“ … (relativ zu APP_TODAY).
import { daysFromToday, formatDate } from '../kern/format';

export interface ConversationSummary {
  id: string;
  title: string;
  href: string;
  /** ISO-Zeitpunkt der letzten Nachricht. */
  updatedAt: string;
  pinned?: boolean;
  active?: boolean;
  /** Läuft gerade eine Antwort (Punkt `animate-live`). */
  streaming?: boolean;
}

export interface ConversationGroup {
  label: string;
  items: ConversationSummary[];
}

function bucketOf(updatedAt: string): string {
  const days = -daysFromToday(updatedAt);
  if (days <= 0) return 'Today';
  if (days === 1) return 'Yesterday';
  if (days <= 7) return 'Previous 7 days';
  if (days <= 30) return 'Previous 30 days';
  return formatDate(updatedAt, 'month');
}

export function groupConversations(items: readonly ConversationSummary[]): ConversationGroup[] {
  const sorted = [...items].sort((a, b) => b.updatedAt.localeCompare(a.updatedAt));
  const groups: ConversationGroup[] = [];
  const pinned = sorted.filter((c) => c.pinned);
  if (pinned.length) groups.push({ label: 'Pinned', items: pinned });
  for (const item of sorted.filter((c) => !c.pinned)) {
    const label = bucketOf(item.updatedAt);
    const last = groups.at(-1);
    if (last && last.label === label) last.items.push(item);
    else groups.push({ label, items: [item] });
  }
  return groups;
}
